import React, { useState, useEffect } from "react";
import {
    Modal,
    Box,
    Typography,
    TextField,
    Button,
    Container
} from "@mui/material";
import { ApiCalls } from '../../services/axios/apiCalls'

function RecoverPasswordModal({ open, onClose, option, launchErrorModal }) {
    /** CONST */
    const [messageInfo, setMessageInfo] = useState("")
    const [messageClass, setMessageClass] = useState("")
    const [email, setEmail] = useState("");
    const [confirmBtn, setConfirmBtn] = useState(true)
    const [closeBtnText, setCloseBtnText] = useState('Cancelar')

    const handleSubmitRecover = async () => {
        setMessageInfo('')
        setMessageClass('')
        setMessageClass('loading-text-circle')
        const apiConfig = {
            method: "POST",
            baseURL: `${process.env.REACT_APP_API_URL}`,
            url: "/password/send",
            mode: "cors",
            data: {
                email
            },
        };

        try {
            const response = await ApiCalls(apiConfig);
            if (response.data.status === 200) {
                setConfirmBtn(false)
                setCloseBtnText('Cerrar')
                setMessageInfo(response.data.message)
                setMessageClass('')
            }
            else {
                setMessageInfo(response.data.message)
                setMessageClass('')
            }
        } catch (error) {
            //launchErrorModal(error.response.status, error.response.message)
            setMessageInfo(error.response.data.message)
            setMessageClass('text-danger')
        }
    };

    return (
        <Modal open={open} onClose={onClose} disableEscapeKeyDown={false}>
            <Container className="box-modal box-modal-lg recovery-box">
                <Box>
                    <Typography className="fw-bold pb-1" variant="h6">Recuperar contraseña</Typography>
                    Para recuperar su contraseña, ingrese el email asociado a su cuenta. Enviaremos a su correo las instrucciones para finalizar la recuperación de su contraseña.
                    <form>
                        {/* Campo correo */}
                        <TextField
                            className="form-username mt-3"
                            size="small"
                            required
                            id="email"
                            label="Email"
                            name="email"
                            value={email}
                            inputProps={{ maxLength: 65 }}
                            onChange={(event) => setEmail(event.target.value)}
                        />
                        <div className={messageClass}>
                            {messageInfo}
                        </div>
                        <div className="d-flex justify-content-end me-2">
                            <Button className="btn-secondary px-3 mt-3 mx-2" variant="outlined" onClick={onClose}>{" "}{closeBtnText}{" "}</Button>
                            {confirmBtn &&
                                <Button className="btn-principal px-3 mt-3 mx-2" variant="outlined" type="button" onClick={handleSubmitRecover}>{" "}Confirmar{" "}</Button>
                            }
                        </div>
                    </form>
                </Box>
            </Container>
        </Modal>
    );
}

export default RecoverPasswordModal;
